import { getDodo } from '@boschebike/ebds-js/dist-esm/helpers/dodo.js';
import WelcomeModalSheet from './welcome';
import EnableServiceModalSheet from './enableService';
import GenericMessageModalSheet from './genericMessage';
import InformationModalSheet from './information';

export const initModals = async () => {
  const dodo = await getDodo();

  dodo.ui.registerModal('gooseWelcomeMessage', {
    Component: WelcomeModalSheet,
  });

  dodo.ui.registerModal('gooseInformation', {
    Component: InformationModalSheet,
  });
  /** PORTAL-4303 Remove if not needed */
  dodo.ui.registerModal('gooseEnableService', {
    Component: EnableServiceModalSheet,
  });

  dodo.ui.registerModal('gooseGenericMessage', {
    Component: GenericMessageModalSheet,
    blockingUI: true,
  });
};
